/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=o=>t=>t<=.5?o(2*t)/2:(2-o(2*(1-t)))/2;export{o as mirrorEasing};
//# sourceMappingURL=mirror.js.map
